// Snackbar constants
export const AUTO_HIDE_DURATION = 50000;
export const EMITTER_SUCCESS = "alert_success";
export const EMITTER_WARNING = "alert_warning";
export const EMITTER_ERROR = "alert_error";
export const EMITTER_INFO = "alert_info";
export const SNACKBAR_CONFIG = {
  snackBarPlacement: {
    vertical: "top",
    horizontal: "center",
  },
};
export const CURRENT_YEAR = new Date().getFullYear();
//Connectome URL
export const CONNECTOME_URL = "https://connectomeinc.com/";

// Laptop Size for media queries
export const MEDIA_QUERY_SIZE = "768";
export const EMAIL_ENCODING_SALT = "rnf@tech";
